import { useState, useCallback } from 'react';

/**
 * Build payment dialog preset for pay-and-close using check currency amount due.
 * @returns {object|null}
 */
export function buildPayAndClosePreset(balance, t) {
  if (!balance) return null;
  const currency = balance.checkCurrency;
  const amount = balance.amountDue;
  const due = Number(amount ?? 0);
  if (due <= 0) return null;
  return {
    amount: due,
    currency,
    note: t('clients.payAndCloseNote'),
    submitLabel: t('clients.payAndClose'),
    requirePaymentMethod: true,
  };
}

/**
 * Shared open/close state for Add Payment dialog on check detail screens.
 * @returns {{
 *   paymentDialogOpen: boolean,
 *   paymentDialogPreset: object|null,
 *   openPaymentDialog: function,
 *   closePaymentDialog: function,
 *   openPayAndCloseDialog: function,
 * }}
 */
export function useCheckPaymentDialog(t) {
  const [paymentDialogOpen, setPaymentDialogOpen] = useState(false);
  const [paymentDialogPreset, setPaymentDialogPreset] = useState(null);

  const openPaymentDialog = useCallback((preset = null) => {
    setPaymentDialogPreset(preset);
    setPaymentDialogOpen(true);
  }, []);

  const closePaymentDialog = useCallback(() => {
    setPaymentDialogOpen(false);
    setPaymentDialogPreset(null);
  }, []);

  const openPayAndCloseDialog = useCallback((balance) => {
    const preset = buildPayAndClosePreset(balance, t);
    if (!preset) return;
    openPaymentDialog(preset);
  }, [openPaymentDialog, t]);

  return {
    paymentDialogOpen,
    paymentDialogPreset,
    openPaymentDialog,
    closePaymentDialog,
    openPayAndCloseDialog,
  };
}
